/**
 * 二角取り Solitaire の識別子。
 *
 * **この文字列は5か所で同じ値を指す**（識別子を1つに保つのが方針）:
 *   D1 の `game_key` / `src/games/<ここ>/` / `src/locales/<lang>/<ここ>.json` /
 *   `public/assets/<ここ>/` / localStorage の接頭辞 `<ここ>.*`
 *
 * ※ Phaser を引かない**軽いモジュール**として独立させてある。ダッシュボード（初期バンドル）や
 *   設定スライスがキーだけを欲しがるので、ここを import してもゲーム本体は落ちてこない。
 */
export const GAME_KEY = 'nikakudori';
